import { gql } from '@apollo/client';

export const DELETE_USER_FROM_AUTH0 = gql`
  mutation deleteUserFromAuth0 ($input: DeleteUserFromAuth0Input!) {
    deleteUserFromAuth0(input: $input)
  }
`;
